import emptyIconProfile from "../../images/emptyIconProfile.svg"
import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {Image, Row} from "antd";
import {useNavigate} from "react-router-dom";
import {DiplomaCard} from "../../Components/DiplomaCard";
import usePortalService from "../../services/PortalService";
import { Tooltip } from 'antd';
import star from '../../images/star.svg';
import { Diploma, Reaction as ReactionType } from "../../types";

const Styles = styled.div`
  @media only screen and (max-width: 700px) {
    width: calc(12% + 700px);
  }
`

const TextBlock = styled.p`
  line-height: 22px;
  white-space: pre-line;
  letter-spacing: 0em;
  font-size: 14px;
`
const Name = styled.h1`
    display: inline-block;
    color: #2196F3;
    cursor: pointer;
    margin-bottom: 4px; 
    margin-right: 8px;
`


const HeaderText = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0;
  text-align: left;
  color: #222222;
  margin-bottom: 8px;
`

export const Reaction = ({reaction}: {reaction?: ReactionType}) => {
  const {getAvatar} = usePortalService();

  const navigate = useNavigate()

  const [message, setMessage] = useState<string | undefined>('');

  const [profileId, setProfileId] = useState<number>();
  const [fullName, setFullName] = useState('');
  const [statusFind, setStatusFind] = useState<string | undefined>('');
  const [rating, setRating] = useState<number | undefined>(0);
  const [address, setAddress] = useState('');
  const [educationLevel, setEducationLevel] = useState('');
  const [institution, setInstitution] = useState('');
  const [yearGraduation, setYearGraduation] = useState<number | undefined>();
  const [specialtyName, setSpecialtyName] = useState<string | undefined>('');
  const [isTargetEducation, setIsTagetEducation] = useState<boolean | undefined>(false);
  const [targetCompany, setTargetCompany] = useState<string | undefined>('');
  const [about, setAbout] = useState<string | undefined>('');
  const [avatar, setAvatar] = useState('');

  const [position, setPosition] = useState('');

  const [diplomas, setDiplomas] = useState<Diploma[] | undefined>([]);

  const [queryError, setQueryError] = useState('');

  const detectPosition = (yearGraduation: number) => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const academicYearIsOver = (now.getMonth() > 5)
    if (currentYear > yearGraduation) {
      setPosition("Выпускник "+yearGraduation+" года.")
    } else if (currentYear === yearGraduation) {
      if (academicYearIsOver) {
        setPosition("Выпускник этого года.")
      } else {
        setPosition("Студент, последний курс.")
      }
    } else {
      // TODO : настроить получение общей длительности обучения, когда появятся необходимые данные
      const course = 4 - (yearGraduation - currentYear) + (academicYearIsOver ? 1 : 0)
      setPosition("Студент, "+course+" курс.")
    }

  }

  useEffect(() => {
    if (reaction) {
        setProfileId(reaction.profile.id);
        setMessage(reaction.message);
        setFullName(reaction.profile.fullName)
        setStatusFind(reaction.profile.status)
        setRating(reaction.profile.rating)
        setAddress(reaction.profile.region+', '+reaction.profile.city)
        setEducationLevel(reaction.profile.educationLevel)
        setInstitution(reaction.profile.educationalInstitution)
        setYearGraduation(reaction.profile.yearGraduation)
        setSpecialtyName(reaction.profile.specialtyName)
        setAbout(reaction.profile.aboutMe)
        setIsTagetEducation(reaction.profile.isTargetEducation)
        setTargetCompany(reaction.profile.targetCompany)
        if (reaction.profile.avatarId) {
          getAvatar(reaction.profile.avatarId)  
          .then(result => {
              setAvatar(result)
          })
        } else {
            setAvatar(emptyIconProfile)
        }
        detectPosition(Number(reaction.profile.yearGraduation))
        setDiplomas(reaction.profile.certificates)
        setQueryError('');
    }
  },[reaction])

  const nameClickHandle = () => {
      if (profileId) {
          navigate('/candidate/'+profileId);
      }
  }

  return(
    <Styles id="main">
      <div className="page700 d-flex flex-column gap-4">
        <div className='d-flex gap-3'>
          <Image src={avatar} style={{height : 112, objectFit : "cover", aspectRatio: "1/1", borderRadius : "0.5em"}}/>
          <div className="d-flex flex-column gap-1">
            <div className="header-card">
                <Name onClick={nameClickHandle}> {fullName} </Name>
                {(statusFind) && <div className="find-candidate-card"> {statusFind} </div>}
            </div>
            <div className="row-container">
                <img src={star} width="16px" style={{marginTop:'-5px'}}/>
                <p className="hours-number" style={{ marginBottom: '4px' }}>
                    {rating}
                </p>
                <Tooltip placement='bottom'
                title="Рейтинг РТСИМ - рейтинг, основанный на данных по использованию компьютерных тренажеров РТСИМ.Карьера.">
                    <h6 style={{ marginBottom: '4px' }}>
                        Рейтинг РТСИМ
                    </h6>
                </Tooltip>
            </div>
            {
              !(position && ((isTargetEducation && targetCompany) || !isTargetEducation))
                ? <TextBlock>Образование не заполнено</TextBlock>
                : <TextBlock> {position} {isTargetEducation ? `Целевой (${targetCompany})` : null}</TextBlock>
            }
            {
              !(address)
                ? <TextBlock>Адрес не заполнен</TextBlock>
                : <TextBlock> {address} </TextBlock>
            }
            <div className="d-flex gap-2">
            </div>
          </div>
        </div>
        {(message) && <div>
          <p className="error-alert">{queryError}</p>
          <HeaderText>Сопроводительное письмо</HeaderText>
          <TextBlock>
            {message}
          </TextBlock>
        </div>}
        <div>
          <HeaderText>{educationLevel}</HeaderText>
          <TextBlock>
            {`${yearGraduation ? `${yearGraduation} год окончания` : 'Год окончания : не заполнено'}
            ${institution ?? 'Образовательное учреждение : не заполнено'}
            ${specialtyName ?? 'Название специальности : не заполнено'}`}
          </TextBlock>
        </div>
        <div>
          <HeaderText>Обо мне</HeaderText>
          <TextBlock>
            {(about) ? about : "Не заполнено"}
          </TextBlock>
        </div>
        <div>
          <HeaderText>Дипломы и сертификаты</HeaderText>
          {
            diplomas
              ? 
              <Row>
                {diplomas.map(diploma =>
                  <DiplomaCard key={diploma.id} diploma={diploma}/>
                )}
              </Row>
              : <TextBlock>Не загружено</TextBlock>
          }
        </div>
      </div>
    </Styles>
  )
}